import { render, staticRenderFns } from "./StudentDetail.vue?vue&type=template&id=01eb47e6&"
import script from "./StudentDetail.vue?vue&type=script&lang=js&"
export * from "./StudentDetail.vue?vue&type=script&lang=js&"
import style0 from "./StudentDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports